import { IRatingRequestInput, IUpdateAppointmentRatingResponse } from "./appointment-rating.interface";

import { DASHBOARD } from "../dashboard/dashboard.query";
import { UPDATE_APPOINTMENT_RATING } from "./appoinment-rating.mutation";
import { useMutation } from "@apollo/client";

export const useUpdateAppointmentRating = () => {
  const [updateAppointmentRating, { data, loading }] =
   useMutation<{ updateAppointmentRating: IUpdateAppointmentRatingResponse }>(UPDATE_APPOINTMENT_RATING);

  const updateAppointmentRatingMutation = (input: IRatingRequestInput) => {
    updateAppointmentRating({
      variables: { data: input },
      refetchQueries: [
        { query: DASHBOARD },
      ],
    });
  };

  return {
    updateAppointmentRatingMutation,
    data: data?.updateAppointmentRating,
    appointmentPlaceId: data?.updateAppointmentRating?.appointmentPlaceId,
    loading,
  };
};
